import { Button, Table, Typography } from "antd";
import { CiTrash } from "react-icons/ci";
import "./PlanTable.css";
import { getPercentages } from "../../../Colors/percentages";
import { useSelector } from "react-redux";

const { Paragraph } = Typography;

export const PlanTable = ({
  plan,
  setPlan,
  drills,
  metrics,
  costPerMin,
  teamInfo,
  handleRemovePlan,
  editable = true,
}) => {
  const { colors: calendarColors } = useSelector(({ calendar }) => calendar);
  const { colors_1, colors_2 } = useSelector(({ dualCalendar }) => dualCalendar);
  const colors = Object.keys(calendarColors || {}).length > 0
    ? calendarColors
    : Object.keys(colors_2 || {}).length > 0
      ? colors_2
      : (colors_1 || {});
  const handleChangeDuration = (index) => (value) => {
    const duration = value.trim() === "" ? 0 : value;
    setPlan(
      plan.map((item, i) => (i === index ? { ...item, duration } : item))
    );
  };

  const columns = [
    {
      title: "Drill",
      dataIndex: "drill_id",
      key: "drill_id",
      width: 200,
      align: "left",
      render: (drill_id) =>
        <div style={{ textAlign: 'left' }}>
          {drill_id !== "total"
            ? drills.find((drill) => drill.drill_id === drill_id)?.name
            : "Total Sum"}
        </div>
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      width: 100,
      render: (duration, { drill_id }, index) => (
        <Paragraph
          editable={
            !editable || drill_id === "total"
              ? false
              : {
                  value: duration,
                  onChange: handleChangeDuration(index),
                }
          }
          style={{ margin: 0, marginLeft: 8 }}
        >
          {duration}
        </Paragraph>
      ),
    },
    ...Object.keys(costPerMin?.[0] || {})
      .filter(
        (key) =>
          key !== "drill_id" && (teamInfo?.key_metrics || []).includes(key)
      )
      .map((metric_key) => ({
        title: metrics.find((metric) => metric.key === metric_key)?.name,
        dataIndex: "drill_id",
        key: metric_key,
        width: 100,
        render: (drill_id, { duration }) => {
          const value =
            drill_id !== "total"
              ? (
                  (costPerMin.find((item) => item.drill_id === drill_id) || {})[
                    metric_key
                  ] * duration
                ).toFixed(2)
              : plan
                  .reduce(
                    (cur, item) =>
                      cur +
                      +item.duration *
                        +(costPerMin.find(
                          (p) => p.drill_id === item.drill_id
                        ) || { [metric_key]: 0 })[metric_key],
                    0
                  )
                  .toFixed(2);
          const color =
            drill_id !== "total"
              ? "#000000"
              : value > colors[metric_key] * getPercentages(metric_key).upper
              ? "#dc3545"
              : value > colors[metric_key] * getPercentages(metric_key).middle
              ? "#EF7616"
              : value > colors[metric_key] * getPercentages(metric_key).lower
              ? "#ffc107"
              : "#28a745";
          return drill_id === "total" ? (
            <strong style={{ color }}>{value}</strong>
          ) : (
            value
          );
        },
      })),
    ...(editable ? [{
      title: "",
      dataIndex: "drill_id",
      key: "drill_id",
      width: 50,
      render: (drill_id, _, index) =>
        drill_id !== "total" && (
            <CiTrash color="red" onClick={() => handleRemovePlan(index)}/>
        ),
    }] : []),
  ];

  return (
    <Table
      rowClassName={(row, index) =>
        index === plan.length && "plan-table-last-row"
      }
      className="compact-table plan-table"
      dataSource={[
        ...plan,
        {
          drill_id: "total",
          duration: plan.reduce((cur, p) => cur + +p.duration, 0),
        },
      ]}
      scroll={{ y: 360 }}
      columns={columns}
      rowKey={(_, i) => i}
      pagination={false}
      bordered
      size="small"
    />
  );
};
